import React from 'react';
import { BrowserRouter, HashRouter, MemoryRouter } from 'react-router-dom';

export interface RouterProviderProps {
  type?: 'browser' | 'hash' | 'memory';
}

export const RouterProvider: React.FC<RouterProviderProps> = ({
  type = 'browser',
  children,
}) => {
  switch (type) {
    case 'browser':
      return <BrowserRouter>{children}</BrowserRouter>;
    case 'hash':
      return <HashRouter>{children}</HashRouter>;
    case 'memory':
      return <MemoryRouter>{children}</MemoryRouter>;
  }
};
